import { ResourceOptions } from 'react-admin';
import { FaAccessibleIcon } from 'react-icons/fa';
import { Resources } from '../../resource';

export { default as list } from './List';
// export { default as create } from './Create';
// export { default as edit } from './Edit';

export const name = Resources.categories;
export const icon = FaAccessibleIcon;
export const options: ResourceOptions = {
  label: 'resource.categories',
};
